import React from 'react';

/**
 * Square Pacarion app mark beside an AI reply.
 * Same file as the installed icon in public/manifest.json (logo512.png).
 * The artwork already includes its dark tile, so one image is used in light and dark.
 * User messages do not use this avatar.
 */
export const PACARION_SQUARE_MARK = `${process.env.PUBLIC_URL || ''}/logo512.png`;

export default function AiReplyAvatar() {
  return (
    <img
      src={PACARION_SQUARE_MARK}
      alt=""
      width={32}
      height={32}
      data-ai-avatar="pacarion-mark"
      style={{
        width: 32,
        height: 32,
        flexShrink: 0,
        marginBottom: '0.25rem',
        display: 'block',
        objectFit: 'contain',
        background: 'transparent',
      }}
    />
  );
}
